import { render, staticRenderFns } from "./DebugLogsSection.vue?vue&type=template&id=3365146c&scoped=true&"
import script from "./DebugLogsSection.vue?vue&type=script&lang=js&"
export * from "./DebugLogsSection.vue?vue&type=script&lang=js&"
import style0 from "./DebugLogsSection.vue?vue&type=style&index=0&id=3365146c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3365146c",
  null
  
)

export default component.exports